/* eslint-disable prettier/prettier */
import request from '@/utils/request';
import axios from 'axios';
import qs from 'qs';

// import global from '@/config/config';
const SERVER_URL = process.env.VUE_APP_SERVER_URL;
const CRM3_URL = process.env.CRM3_URL;

export async function getCityData() {
  return axios.get('https://res.miaocode.com/country/citylist.json').then(res => {
    return res.data;
  });
}

export async function getGradeList() {
  return await request.get(`${SERVER_URL}/activity/getGradeList`);
}

export async function subscribe(params) {
  return await request.get(`${CRM3_URL}/crm-market/portal/subscribe`, { params });
}

// 创建9.9订单
export async function createDemoOrder(params) {
  return await request.post(
    `${SERVER_URL}/goodsOrder/createDemoOrder`,
    qs.stringify(params),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
  );
}

// 获取汇率
export async function getExchangeRate(params) {
  return await request.get('/payPal/exchangeRate', { params });
}

export async function captchaVerify(opt) {
  return await request.post(`${SERVER_URL}/common/captchaVerify`, opt, {
    headers: { 'Content-Type': 'application/json' },
  });
}

export async function getSMS2(params) {
  // return await request.get(`${SERVER_URL}/ccbb/sendSMS2`, { params });
  return await request.get(`${SERVER_URL}/ccbb/captcha/sendSMS2`, { params });
}

export async function getActivityStatus(params) {
  return await request.get(`${CRM3_URL}/crm-market/portal/getActivityStatus`, { params });
}

export async function getActivityType(params) {
  return await request.get(`${CRM3_URL}/crm-market/market/pushActivity/getActivityType`, { params });
}

export async function register(params) {
  return await request.post(`${SERVER_URL}/user/register`, params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  });
}

export function getPageConfByChannelCode(channelCode) {
  return request.get(`${CRM3_URL}/crm-market/floorPageOpen/getFpConfByChannelCode?channelCode=${channelCode}`, {
    channelCode: channelCode,
  });
}

export async function getFormResourceData(formResourceId) {
  return await axios.get(`${CRM3_URL}/crm-market/floorPageOpen/getFormResourceData?formResourceId=${formResourceId}`, {
    formResourceId: formResourceId,
  });
}

export async function sendSmsCode(params) {
  // return await axios.post(
  //   `${CRM3_URL}/crm-market/portal/sendSmsCode`,
  //   { ...params },
  //   { headers: { 'Content-Type': 'application/json' } },
  // );
  return await axios.post(
    // `${CRM3_URL}/crm-market/portal/sendSmsCode2`,
    `${CRM3_URL}/crm-market/portal/captcha/sendSmsCode`,
    { ...params },
    { headers: { 'Content-Type': 'application/json' } },
  );
}

export async function listSchool(activityCode) {
  return await axios.get(`${CRM3_URL}/crm-market/portal/listSchool?activityCode=${activityCode}`, {});
}

// 3.0的落地页入库接口
export async function register3(params) {
  return await request.post(`${CRM3_URL}/crm-market/portal/register`, params, {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  });
}

// 3.0的落地页入库后根据ccid获取企微二维码 可能为空
export async function getPersonQrCode(params) {
  return await request.get(`${CRM3_URL}/crm-account/enterpriseWeChat/getContactQrCode`, { params });
}

export async function getLeadsWxCpContact(params) {
  return await request.get(`${CRM3_URL}/crm-market/leadsWxCpContact/contact`, { params });
}

// 根据商品编号获取商品详情
export async function getGoodsDetail(params) {
  return await request.get(`${CRM3_URL}/crm-order/goods/getGoodsDetail`, {
    params
  });
}



// WEBPACK FOOTER //
// ./src/pages/landing-page/services/api.js